import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Search from '../common/cmpt/search/Search';
import store, { persistor } from '../store';

export const SearchWidget = (id) => {
  const node = document.getElementById(id);
  const root = ReactDOM.createRoot(node);

  root.render(
    <Provider store={store}>
      <PersistGate loading={<></>} persistor={persistor}>
        <React.StrictMode>
          <Suspense fallback={<></>}>
            <Search id="desktop-typeahead" />
          </Suspense>
        </React.StrictMode>
      </PersistGate>
    </Provider>,
  );
};
